import type { Draft } from '~publish/legacy/composer/composer/entities/Draft'

/**
 * AI disclosure can only be sent when the network API accepts it: direct
 * publishing (not reminders), TikTok video posts only (the photo API has no
 * field), YouTube videos, original X tweets (never retweets), and Instagram
 * (all post types).
 */
export function canDiscloseAiContent(draft: Draft): boolean {
  if (draft.isReminder) {
    return false
  }
  if (draft.service.isTiktok()) {
    return !draft.hasImagesAttachment()
  }
  if (draft.service.isYoutube()) {
    return true
  }
  if (draft.service.isTwitter()) {
    return !draft.retweet
  }
  if (draft.service.isInstagram()) {
    return true
  }
  return false
}

export function getIsAiGenerated(draft: Draft): boolean {
  return Boolean(
    draft.channelData?.tiktok?.is_ai_generated ??
    draft.channelData?.youtube?.is_ai_generated ??
    draft.channelData?.twitter?.is_ai_generated ??
    draft.channelData?.instagram?.is_ai_generated,
  )
}
